export default __webpack_public_path__ + "static/media/cosmiczoo.35598f49.png";